import {
    BeltContainer,
    createBeltContainer,
} from '@vfde-brix/ws10/belt-container';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import {
    ERROR_NOTIFICATION_CONTAINER_ID,
    HTML_CONTAINER_ID_PREFIX,
} from 'Container/App/constants';
import { selectHasError } from 'Container/App/selectors';
import { startAppListening } from 'Container/App/listener';

/**
 * Mounts a BeltContainer by ID
 */
const mountBeltContainer = (containerId: string): BeltContainer | null => {
    const containerElement = document.getElementById(containerId);

    if (!containerElement) {
        /* istanbul ignore next */
        return null;
    }

    return createBeltContainer(containerElement, NO_PATTERN_BUSINESS_LOGIC);
};

export default mountBeltContainer;

/**
 * Mount belt container for error notification
 */
export const mountBeltContainerForError = () => {
    const beltContainer = mountBeltContainer(ERROR_NOTIFICATION_CONTAINER_ID);

    startAppListening({
        predicate: (action, currentState, previousState) =>
            selectHasError(currentState) !== selectHasError(previousState),
        effect: (action, listenerApi) => {
            listenerApi.cancelActiveListeners();

            const hasError = selectHasError(listenerApi.getState());

            beltContainer?.toggleContainer(!hasError);
        },
    });
};

/**
 * Mount belt container for integration layer
 */
export const mountBeltContainerForApp = () => {
    const beltContainer = mountBeltContainer(HTML_CONTAINER_ID_PREFIX);

    startAppListening({
        predicate: (action, currentState, previousState) =>
            selectHasError(currentState) !== selectHasError(previousState),
        effect: (action, listenerApi) => {
            listenerApi.cancelActiveListeners();

            const hasError = selectHasError(listenerApi.getState());

            beltContainer?.toggleContainer(hasError);
        },
    });
};
